import * as React from "react";

import { Route, Routes, Navigate, PathRouteProps, useLocation } from "react-router-dom";
import { userInfoStore } from "Stores/UserInfoStore";
import { userSettingsStore } from "Stores/UserSettingsStore";
// import { RouteWithTitle } from "Components/Utils/RouteWithTitle";
import { observer } from "mobx-react";

/**
 * Private Route ensures that the correct Wrapper is used
 *
 * Redirects to login when Authentication Failed
 */
interface PrivateRouteProps extends PathRouteProps {
  roles?: Roles[];
  pageName?: string;
}

export const PrivateRoute: React.FC<PrivateRouteProps> = observer((props) => {
  const location = useLocation();
  const roles = props.roles || (["ALL"] as Roles[]);

  if (userInfoStore.isAuthenticated) {
    if (userInfoStore.role && userInfoStore.role !== "GUEST") {
      userSettingsStore.getSettingsIfNew();
    }
    if (userSettingsStore.state === "LOADING") {
      return null;
    }
    if (userInfoStore.isVisibleFor(roles)) {
      return <>{props.children}</>;
    } else {
      return <Navigate to={{ pathname: "/" }} />;
    }
  }
  return <Navigate to={{ pathname: "/login" }} state={{ from: location }} />;
});
PrivateRoute.displayName = "PrivateRoute";

export const SwitchWith404 = (props) => {
  return (
    <Routes>
      <Route element={<Navigate to="/404" />} />
      {props.children}
    </Routes>
  );
};
